import {put, takeLatest, call} from 'redux-saga/effects';
import {SUCCESS_KEY} from 'constants/keys';
import {
  getProjectsFailure,
  getProjectsRequest,
  getProjectsSuccess,
  getProjectsSuccessResponse,
  getProjectsRequestParams,
  addProjectRequest,
  addProjectFailure,
  addProjectSuccess,
  addProjectRequestPayload,
  addProjectSucessResponse,
  addEmployeeToProjectFailure,
  addEmployeeToProjectRequest,
  addEmployeeToProjectSuccess,
  addEmployeeToProjectRequestPayload,
  addEmployeeToProjectSuccessResponse,
  updateProjectRequest,
  updateProjectSuccess,
  updateProjectFailure,
  updateProjectRequestPayload,
  updateProjectSucessResponse,
  getProjectDetailsRequest,
  getProjectDetailsSuccess,
  getProjectDetailsFailure,
  getProjectDetailsParams,
  getProjectDetailsSuccessResponse,
  getProjectMemberParams,
  getProjectMemberSuccessResponse,
  getProjectTeamMemberFailure,
  getProjectTeamMemberRequest,
  getProjectTeamMemberSuccess,
} from 'redux/slices/projectSlice';
import {
  getProject,
  addProject as addProjectAPI,
  addEmployeeToProject,
  updateProject as updateProjectAPI,
  getProjectDetails as getProjectDetailsAPI,
  projectTeamMembers,
} from 'services/api';

/**
 * types for get projects
 */
type GetProjectsRequestAction = {
  type: typeof getProjectsRequest.type;
  payload: getProjectsRequestParams;
};

type GetProjectsResponse = {
  status: string;
} & getProjectsSuccessResponse;

/**
 * types of add projects
 */
type AddProjectsRequestAction = {
  type: typeof addProjectRequest.type;
  payload: addProjectRequestPayload;
};

type AddProjectsResponse = {
  status: string;
} & addProjectSucessResponse;

/**
 * types off add member to project
 */
type AddMemberToProjectRequestAction = {
  type: typeof addEmployeeToProjectRequest.type;
  payload: addEmployeeToProjectRequestPayload;
};

type AddMemberToProjectResponse = {
  status: string;
} & addEmployeeToProjectSuccessResponse;

/**
 * types of update project
 */
type UpdateProjectRequestAction = {
  type: typeof updateProjectRequest.type;
  payload: updateProjectRequestPayload;
};

type UpdateProjectResponse = {
  status: string;
} & updateProjectSucessResponse;

/**
 * type to get project details
 *  */
type GetProjectDetailsAction = {
  type: typeof getProjectDetailsRequest.type;
  payload: getProjectDetailsParams;
};

type GetProjectDetailsResponse = {
  status: string;
} & getProjectDetailsSuccessResponse;

/**
 * type of get project team member
 */

type GetProjectTeamMemberAction = {
  type: typeof getProjectTeamMemberRequest.type;
  payload: getProjectMemberParams;
}

type GetProjectTeamMemberResponse = {
  status: string;
} & getProjectMemberSuccessResponse;

/**
 * saga function for get projects
 */
function* projects(action: GetProjectsRequestAction): Generator {
  try {
    const response: GetProjectsResponse = yield call(
      getProject,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getProjectsSuccess(response));
    } else {
      yield put(getProjectsFailure(response.status_code));
    }
  } catch (error) {
    yield put(getProjectsFailure('E-10001'));
  }
}

/**
 * saga function for add projects
 */
function* addProject(action: AddProjectsRequestAction): Generator {
  try {
    const response: AddProjectsResponse = yield call(
      addProjectAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(addProjectSuccess(response));
    } else {
      yield put(addProjectFailure(response.status_code));
    }
  } catch (error) {
    yield put(addProjectFailure('E-10001'));
  }
}

/**
 * saga function for add employee to project
 */
function* addTeamMember(action: AddMemberToProjectRequestAction): Generator {
  try {
    const response: AddMemberToProjectResponse = yield call(
      addEmployeeToProject,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(addEmployeeToProjectSuccess(response));
    } else {
      yield put(addEmployeeToProjectFailure(response.status_code));
    }
  } catch (error) {
    yield put(addEmployeeToProjectFailure('E-10001'));
  }
}
/**
 * saga function for update project
 */
function* updateProject(action: UpdateProjectRequestAction): Generator {
  try {
    const response: UpdateProjectResponse = yield call(
      updateProjectAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(updateProjectSuccess(response));
    } else {
      yield put(updateProjectFailure(response.status_code));
    }
  } catch (error) {
    yield put(updateProjectFailure('E-10001'));
  }
}
/**
 * saga function to get project details
 */

function* getProjectDetails(action: GetProjectDetailsAction): Generator {
  try {
    const response: GetProjectDetailsResponse = yield call(
      getProjectDetailsAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getProjectDetailsSuccess(response));
    } else {
      yield put(getProjectDetailsFailure(response.status_code));
    }
  } catch (error) {
    yield put(getProjectDetailsFailure('E-10001'));
  }
}

/*
 * saga function to get project members
 */
function* getProjectMembers(action: GetProjectTeamMemberAction): Generator {
  try {
    const response: GetProjectTeamMemberResponse = yield call(
      projectTeamMembers,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getProjectTeamMemberSuccess(response));
    } else {
      yield put(getProjectTeamMemberFailure(response.status_code));
    }
  } catch (error) {
    yield put(getProjectTeamMemberFailure('E-10001'));
  }
}

export function* projectSaga() {
  yield takeLatest(getProjectsRequest.type, projects);
  yield takeLatest(addProjectRequest.type, addProject);
  yield takeLatest(addEmployeeToProjectRequest.type, addTeamMember);
  yield takeLatest(updateProjectRequest.type, updateProject);
  yield takeLatest(getProjectDetailsRequest.type, getProjectDetails);
  yield takeLatest(getProjectDetailsRequest.type, getProjectDetails);
  yield takeLatest(getProjectTeamMemberRequest.type, getProjectMembers);
}
